import React from 'react';
import i18next from 'i18next';
import { string, func } from 'prop-types';

import Badge from '~components/Badge';
import { DELIVERY_STATUS } from '~constants/delivery';

import { DELIVERY_STATUS_BADGE_CONFIG } from './constants';

function DeliveryStatusBadge({ status, style, onClick }) {
  const badgeProps = DELIVERY_STATUS_BADGE_CONFIG[status];
  return (
    <Badge
      style={style}
      {...(status === DELIVERY_STATUS['REJECTED'] && { onClick: onClick })}
      {...badgeProps}>
      {i18next.t(`DeliveryStatus:${status}`)}
    </Badge>
  );
}

DeliveryStatusBadge.propTypes = {
  status: string.isRequired,
  style: string,
  onClick: func
};

export default DeliveryStatusBadge;
